<template>
    <div class="policy-text">
        <div v-if="$route.params.lang == 'th'">
            โปรดอ่านและทำความเข้าใจเกี่ยวกับ <router-link :to="'/' + $route.params.lang + '/privacy'" target="_blank">นโยบายการใช้มูลส่วนบุคคล</router-link> และ <router-link :to="'/' + $route.params.lang + '/term'" target="_blank"> ข้อกำหนดการใช้งาน</router-link> เนื่องจากบริษัท โปรเฟสชั่นแนล บี โพสิทีฟ จำกัด มีการเก็บรวบรวมข้อมูลส่วนตัวเมื่อท่านใช้งานเว็บไซต์ของเรา ทั้งนี้เพื่อไปใช้สำหรับเข้าสู่ระบบการเรียนและสอบวัดผลเพื่อนำส่งชื่อเข้าไปที่ เพื่อนำส่งให้ "สำนักงานป้องกันและปราบปรามการฟอกเงิน" หรือ ปปง.
            <div class="accept">
                <input type="checkbox" v-model="isAccept" @change="changeAcceptance($event)" /> ฉันยินยอมรับข้อตกลงและนโยบาบการใช้ข้อมูลส่วนบุคคล
            </div>
        </div>
        <div v-if="$route.params.lang == 'en'">
            Please read and accept to <router-link :to="'/' + $route.params.lang + '/privacy'" target="_blank">privacy policy</router-link> and <router-link :to="'/' + $route.params.lang + '/term'" target="_blank"> term of usage</router-link>. Since, Professional B Positive Co., Ltd. have collected personal information when you use our website. This is required for attending our course and exam in order to share with Thailand Anti-Money Laundering Office (AMLO)
            <div class="accept">
                <input type="checkbox" v-model="isAccept" @change="changeAcceptance($event)" /> I have read and accept to the terms and conditions and the privacy policy
            </div>
        </div>
    </div>
    
</template>

<script>

export default {
    data() {
        return {
            isAccept: false
        }
    },
    methods: {
        changeAcceptance(e) {
            this.$emit('updateAcceptance', e.target.checked);
        }
    }
}
</script>

<style lang="scss" scoped>
.policy-text {
    color: #333;
    font-size: 12px;
    padding-bottom: 5px;

    .accept {
        margin-top: 8px;
        display: flex;
        align-items: center;

        input {
            margin-right: 10px;
        }
    }
}
</style>